import React from 'react'

const WhiteRecordIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="33" height="33" fill="url(#pattern0_179_523)"/>
      <defs>
        <pattern id="pattern0_179_523" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_179_523" transform="scale(0.0333333)"/>
        </pattern>
        <image id="image0_179_523" width="30" height="30" preserveAspectRatio="none" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByUlEQVR4nO2WTU4CQRCFZy9x5cIfjBGIehdAt6InQHBh8AaGxK07MR6AKLpCXKGeQuItBNwokM+UFkmHzPT0zJjowpd00knV69dVXdXdnvePvwZgFagC90APeNMh8w5QAdI/KbgCNIAR4ZgAV8BaUtFtYKCLvgNNYBfYBOZ0yLykNvFBOcW4oocaARrFugMnA7SM6KtxIp0AY+AoxqZryp04R873mU7TG1l0RlzQB5ZcCJfT9MYVNda60bUaLi0z1iLxPVNgB3gy2ukxKJ1AVtcaSSZtwtKngmaA/dTSSvUAjhSm4MAmLBeBoBQQaRgKPrx9tbVtwi/qtOFjk/SG4cGHJ30u6NmEh18ukLLYbBj48FJqG9qEBwmF+z68+SCba6qlesPQjZvqjqW4ig7C+bjFVQlpp7pF9CSknco24bQ2uzR9JsCnINWrZy6j6xep+uacLhABcKE7bHkJAdzqWucuzstGddcSiB7rGq/AoiupaDyLtZii02cxH5VcNT4C8spkHTg5I73CrUTdtFlI8p6iRSIVugds6Y2U0rm0zDXwYaQ3WqSzABaAM8fP3kg/huEPvyv0Z1IG7oBno51k3labvWX+4f0CPgF0zksCyiGs6AAAAABJRU5ErkJggg=="/>
      </defs>
    </svg>
  )
}

export default WhiteRecordIcon